import { api } from "../api";

export interface AppNotification {
  id: string;
  tenantId: string;
  userId: string | null;
  staffId: string | null;
  type: string;
  channel: string;
  subject: string | null;
  content: string;
  status: string;
  readAt: string | null;
  createdAt: string;
  metadata?: Record<string, unknown> | null;
}

export const notificationsApi = {
  listMine: () => api.get<AppNotification[]>("/notifications/me").then((r) => r.data),

  markRead: (id: string) => api.patch(`/notifications/${id}/read`).then((r) => r.data),

  send: (body: {
    userId?: string;
    type: "email" | "sms" | "push" | "in_app";
    content: string;
    subject?: string;
    dualChannel?: boolean;
  }) => api.post("/notifications/send", body).then((r) => r.data),
};
